import React from 'react';
import { connect } from 'react-redux';
import {
    Card,
    SmsSignModal,
    ExamDetailsTabs,
    AppType,
} from 'components';
import { push } from 'connected-react-router';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { Button, Form } from 'react-bootstrap';
import { useLocalErrorHandler } from 'hooks';

const InviteDetailsContainer = ({
    setErrorHandler,
    examId,
    fetchExamDetails,
    smsCodeStatus,
    onSendCodeForAcceptExamInvite,
    onPush,
    apiError,
    onAcceptExamInvite,
    acceptExamInviteProcessing,
    examDetailsLoading,
    auth,
    examDetails,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [showSignInvite, setShowSignInvite] = React.useState(false);

    React.useEffect(() => {
        fetchExamDetails(examId);
    }, []);


    const toggleSignModal = (showSignInviteVal: boolean, callback?: () => void) => {
        if (showSignInviteVal && !smsCodeStatus) {
            onSendCodeForAcceptExamInvite({ examId, captcha: '' });
        }

        setShowSignInvite(showSignInviteVal);

        if (callback) {
            callback();
        }
    };

    const handleSubmitInvite = async (code: string, captcha?: string) => {
        const res = await onAcceptExamInvite({ examId, code, captcha });
        if (res) {
            toggleSignModal(false, () => onPush('/participation-requests'));
            onPush('/participation-requests');
        }
    };

    const renderHeaderChild = () => (
        <Button onClick={() => toggleSignModal(true)}>Подтвердить участие</Button>
    );

    const title = examDetails ? examDetails.qualificationTitle : '';

    return (
        <Card
          title={title}
          onClickBack={() => onPush('/participation-requests')}
          apiError={apiError}
          showLoader={examDetailsLoading}
          show404Error={!examDetails}
          headerChild={renderHeaderChild()}
          withBackButton
          withoutPadding
          smallTitle
        >
            {examDetails ? (
                <ExamDetailsTabs
                  examDetails={examDetails}
                  withoutApplicantsTab
                  withoutExpertsTab
                  appType={AppType.Expert}
                />
            ) : null}
            <Form.Control.Feedback className="d-block" type="invalid">
                {apiError && apiError && apiError.type === 'captcha' && apiError.message}
            </Form.Control.Feedback>
            {auth && auth.profile && (
                <SmsSignModal
                  onHide={() => toggleSignModal(false)}
                  onSendPasswordAgain={captcha => onSendCodeForAcceptExamInvite({ examId, captcha })}
                  onSubmit={handleSubmitInvite}
                  phone={auth.profile.phone}
                  show={showSignInvite}
                  processing={acceptExamInviteProcessing}
                  waitingSeconds={smsCodeStatus && smsCodeStatus.waitingSeconds}
                  title="Подтверждение участия"
                  phoneText="Для подтверждения участия в проведении экзамена, введите код из СМС-сообщения, которое было отправлено на номер"
                  submitButtonText="Подтвердить"
                  apiError={apiError}
                />
            )}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    auth: state.auth.auth,
    apiError: state.errors.error,
    examDetails: state.exams.examDetails,
    smsCodeStatus: state.requests.smsCodeStatus,
    examDetailsLoading: Boolean(state.loading.effects.exams.fetchExamDetails),
    acceptExamInviteProcessing: Boolean(state.loading.effects.requests.acceptExamInvite)
        || Boolean(state.loading.effects.requests.rejectExamInvite),
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    fetchExamDetails: dispatch.exams.fetchExamDetails,
    onSendCodeForAcceptExamInvite: dispatch.requests.sendCodeForAcceptExamInvite,
    onAcceptExamInvite: dispatch.requests.acceptExamInvite,
    setErrorHandler: dispatch.errors.setErrorHandler,
});


export default connect(mapState, mapDispatch)(InviteDetailsContainer);

interface InviteDetailsOwnProps {
    examId: string;
}

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps & InviteDetailsOwnProps;
